import Message from "@/types/Message.interface"

export interface StandardError {
    reason: string
    message: string
}

interface State {
    standardErrors: StandardError[]
}

export default {
    state: {
        standardErrors: {
            0: {
                reason: 'Delivered',
                message: 'The message was delivered successfully.'
            },
            1: {
                reason: 'Unknown Failure',
                message: `We didn't recognize the error code provided by the carrier.`
            },
            2: {
                reason: 'Invalid number',
                message: `Looks like the contact has a number that is invalid or malformed. Before resending, confirm that this number can receive text messages!`
            },
            3: {
                reason: 'Message Witheld By Carriers (Click Here)',
                message: `Carrier registration issue or attempting to text a landline. Please reach out to us at support@messagedesk.com for assistance.`,
            },
            4: {
                reason: 'Anti-Spam Rejection',
                message: `The carrier rejected this message as spam. This can happen when a message contains sensitive information, has invalid or harmful links, or is blocked by the carrier.`
            },
            5: {
                reason: 'Destination Unreachable',
                message: `This occurs if the phone is in a bad service area, has a bad connection, or the phone plan is canceled.`
            },
            6: {
                reason: 'Insufficient Funds',
                message: `This occurs if the contact is unreachable when the message was sent. Their phone could be canceled.`
            },
            7: {
                reason: 'Carrier Error',
                message: `This occurs when the contact's carrier has an unknown internal error.`
            },
            8: {
                reason: 'Media Error',
                message: `This occurs when the carrier is unable to retrieve the attached media. The media could be too big, or have invalid encoding. </br> To resize your image, we suggest using https://squoosh.app/ </br></br> To learn more: https://learn.messagedesk.com/en/articles/5983068-message-failures-reducing-the-size-of-media-files`
            },
            9: {
                reason: 'No Delivery Confirmation',
                message: `Your message was sent, but we never got delivery confirmation. In most cases, the message was delivered as expected.`
            },
            10: {
                reason: 'Opted Out',
                message: `The contact has opted-out of receiving messages. We'll need their consent before we can send them a message.`
            },
            11: {
                reason: 'Blocked',
                message: "This number has been blocked from sending and receiving messages. You can change this by viewing this contact's profile."
            },
            12: {
                reason: 'Toll Free Number is not Verified',
                message: "This message failed because you're using an unregistered toll-free phone number. Please register your phone number to redeem better message delivery: https://forms.clickup.com/8488321/f/831c1-16980/MAN3OMCRZNGUFA0C6U"
            },
            13: {
                reason: 'Invalid Short Link',
                message: "This message failed because it includes an untrusted short link. Please use MessgeDesk short links if you'd like to include short links in your messages."
            },
            14: {
                reason: 'Invalid message',
                message: `Something is strange about the message text. Encoding errors can occur when a carrier doesn't recognize a unique character.`
            },
            15: {
                reason: 'Message Exceeded Carrier Throughput Limits (Click Here)',
                message: 'This message was blocked by carriers for exceeding your SMS throughput limit. Please reach out to us at support@messagedesk.com to inquire about increasing your SMS throughput'
            }
        }
    },
    mutations: {},
    actions: {},
    getters: {
        getErrorMessage: (state: State) => (message: Message): StandardError => {
            const errors = state.standardErrors

            const code = message?.standard_err

            if (!code) return errors[1]

            return errors[code]
        },
        standardErrors(state: State): StandardError[] {
            return state.standardErrors
        }
    }
}